/*
 Created by qing 2020/3/2 6:03 下午
 */

import {
  Table,
  TableColumn,
  Alert,
  Pagination,
  Popover,
  Button,
  Tooltip,
  Image,
  Tree,
  Select,
  Option,
  DatePicker,
  Progress,
  Input,
  Avatar,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Radio,
  RadioButton,
  RadioGroup,
  Tabs,
  TabPane,
  Tag,
  Form,
  FormItem,
  Dialog,
  Loading,
  InfiniteScroll,
  MessageBox,
  Row,
  Col,
  Timeline,
  TimelineItem, Steps
} from 'element-ui'

const element = {
  install: function (Vue) {
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Alert)
    Vue.use(Pagination)
    Vue.use(Popover)
    Vue.use(Button)
    Vue.use(Tooltip)
    Vue.use(Image)
    Vue.use(Tree)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(DatePicker)
    Vue.use(Progress)
    Vue.use(Avatar)
    Vue.use(Input)
    Vue.use(Checkbox)
    Vue.use(CheckboxButton)
    Vue.use(CheckboxGroup)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Tag)
    Vue.use(Radio)
    Vue.use(RadioButton)
    Vue.use(RadioGroup)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Dialog)
    Vue.use(Col)
    Vue.use(Row)
    Vue.use(Timeline)
    Vue.use(TimelineItem)
    Vue.use(InfiniteScroll)
    Vue.use(Loading.directive);
    Vue.use(Steps)
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$loading = Loading.service;
  }
}
export default element
